import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Network3"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 7.5H7.5V1.5H1.5V7.5ZM16.5 12.75H18C20.4853 12.75 22.5 10.7353 22.5 8.25C22.5 5.76472 20.4853 3.75 18 3.75H9V5.25H18C19.6569 5.25 21 6.59315 21 8.25C21 9.90685 19.6569 11.25 18 11.25H16.5V12.75ZM3 6H6V3H3V6ZM9 15H15V9H9V15ZM13.5 13.5H10.5V10.5H13.5V13.5ZM22.5 22.5H16.5V16.5H22.5V22.5ZM18 21H21V18H18V21ZM1.5 15.75C1.5 18.2353 3.51472 20.25 6 20.25H15V18.75H6C4.34315 18.75 3 17.4069 3 15.75C3 14.0931 4.34315 12.75 6 12.75H7.5V11.25H6C3.51472 11.25 1.5 13.2647 1.5 15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Network3.vue"]]);
